<app-header></app-header>

<section>
  <div class="container">    
      <div class="text-center">
        <div class="forgotdiv">         
            <h2>Credentials for Login</h2>
            <hr />          
          <form [formGroup]="form">
            <div class="row text-start mb-3">
              <div class="col-md-12">
                <label class="nowrap">USERNAME <span class="text-danger">*</span></label>
                <input type="text" autocomplete="off" formControlName="msMeUserName" class="form-control"
                       id="txtUsername" placeholder="UDYAM-MH-XX-XXXXXXX" maxlength="19">
                <div *ngIf="form.get('msMeUserName')?.touched && form.get('msMeUserName')?.invalid" class="alert alert-danger">
                  <div *ngIf="form.get('msMeUserName')?.errors?.['required']">
                    UDYAM Number is required
                  </div>
                  <div *ngIf="form.get('msMeUserName')?.errors?.['minlength']">
                    UDYAM Number is too short
                  </div>
                  <div *ngIf="form.get('msMeUserName')?.errors?.['maxlength']">
                    UDYAM Number is too long
                  </div>
                  <div *ngIf="form.get('msMeUserName')?.errors?.['invalidUdyamnum']">
                    Invalid UDYAM Number
                  </div>
                </div>

                <label class="nowrap">PASSWORD <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input [type]="showPassword ? 'text' : 'password'" autocomplete="off" formControlName="password"
                         class="form-control" id="txtpassword" placeholder="Password" minlength="8">
                  <div class="input-group-append">
                    <span class="input-group-text" (click)="toggleShowPassword()" style="cursor: pointer;height:39px">
                      <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </span>
                  </div>
                </div>
                <div *ngIf="f['password'].touched && f['password'].invalid" class="alert alert-danger">
                  <div *ngIf="f['password'].errors && f['password'].errors['required']">
                    Password is required
                  </div>
                  <div *ngIf="f['password'].errors && f['password'].errors['minlength']">
                    Minimum length should be 8 characters
                  </div>
                  <div *ngIf="f['password'].errors && f['password'].errors['pattern']">
                    <p>Password does not match the minimum criteria as mentioned below:</p>
                    <ul>
                      <li>Be a minimum of eight (8) characters in length</li>
                      <li>Contains at least one (1) character from the following categories:</li>
                      <ul>
                        <li>Uppercase letter (A-Z)</li>
                        <li>Lowercase letter (a-z)</li>
                        <li>Digit (0-9)</li>
                        <li>Special character (~`!&#64;#$%^&amp;*\/<>,.)</li>
                      </ul>
                    </ul>
                  </div>

                </div>

                <label class="nowrap">CONFIRM PASSWORD <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input [type]="showConfirmPassword ? 'text' : 'password'" autocomplete="off" formControlName="confpassword"
                         class="form-control" id="txtConfirmpassword" placeholder="Retype-Password" (paste)="onPaste($event)">
                  <div class="input-group-append">
                    <span class="input-group-text" (click)="toggleShowConfirmPassword()" style="cursor: pointer;height:39px">
                      <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </span>
                  </div>
                </div>
                <div *ngIf="f['confpassword'].touched && f['confpassword'].invalid" class="alert alert-danger">
                  <div *ngIf="f['confpassword'].errors && f['confpassword'].errors['required']">
                    Confirm Password is required
                  </div>
                  <div *ngIf="f['confpassword'].errors && f['confpassword'].errors['minlength']">
                    Minimum length should be 8 characters
                  </div>
                  <div *ngIf="f['confpassword'].errors?.['passwordMismatch']" class="alert alert-danger required">
                    Password and Confirm Password fields must match.
                  </div>
                </div>
              </div>
            </div>
           
            <button id="btngotocontact" type="button" (click)="goto(form)" class="btn btn-success me-2">Save</button>
            <button id="btncancel" type="button" (click)="onReset()" class="btn btn-danger">Cancel</button>
          </form>
        </div>
      </div>
    
  </div>
</section>
<app-footer></app-footer>
